import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    html{
        direction:${({ theme }) => theme.direction};
    }
    html,body,#root{
        width:100%;
        height:100%;
    }
    body{
        background-color:${({ theme }) => theme.colors.background};
        font-family:${({ theme }) => theme.fontFamily.main};
        color: ${({ theme }) => theme.colors.font};
    }
    a{
        text-decoration:none;
        color:${({ theme }) => theme.colors.link};
        &:hover{
            color:${({ theme }) => theme.colors.linkHover};
        }
    }
    *{
        outline:none;
        box-sizing: border-box;
    }
    h1,h2,h3,h4,h5,h6{
        font-family: ${({ theme }) => theme.fontFamily.main};
        color: ${({ theme }) => theme.colors.font};
        font-weight: bold;
    }
    h1{
        font-size:${({ theme }) => theme.sizes.font6};
    }
    h2{
        font-size:${({ theme }) => theme.sizes.font5};
    }
    h3{
        font-size:${({ theme }) => theme.sizes.font4};
    }
    h4{
        font-size:${({ theme }) => theme.sizes.font3};
    }
    h5{
        font-size:${({ theme }) => theme.sizes.font2};
    }
    h6{
        font-size:${({ theme }) => theme.sizes.font1}; 
    }
    .currency{
        font-size: 0.6em;
    }
    .Toastify__toast{
        direction: rtl !important;
        font-family: ${({ theme }) => theme.fontFamily.main} !important;
    }
    .Toastify__close-button{
        align-self: normal !important;
    }
    .Toastify__toast-body {
        align-items: flex-start !important;
    }
`;
